import { useSyncExternalStore } from "react";
import type { MemberPlanRole } from "./can";

const RANK: Record<MemberPlanRole, number> = {
  owner: 4,
  admin: 3,
  editor: 2,
  contributor: 1,
  viewer: 0,
};

export type RoleDemotion = { from: MemberPlanRole; to: MemberPlanRole };

let notice: RoleDemotion | null = null;
let version = 0;
const listeners = new Set<() => void>();

function emit() {
  version += 1;
  for (const listener of listeners) listener();
}

export function resetRoleDemotion(): void {
  notice = null;
  emit();
}

export function getRoleDemotion(): RoleDemotion | null {
  return notice;
}

export function subscribeRoleDemotion(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useRoleDemotion(): number {
  return useSyncExternalStore(subscribeRoleDemotion, () => version, () => version);
}

export function isDemotion(from: MemberPlanRole, to: MemberPlanRole): boolean {
  return RANK[to] < RANK[from];
}

/** 저장하지 않은 편집은 강등해도 같은 값으로 남는다. */
export function editsAfterDemotion<T>(edits: T): T {
  return edits;
}

/** 더 낮은 역할로 바꾸고 저장하지 않은 편집이 있을 때만 배너를 띄운다. */
export function noteRoleDemotion(from: MemberPlanRole, to: MemberPlanRole, dirty: boolean): void {
  if (!dirty || !isDemotion(from, to)) {
    notice = null;
  } else {
    notice = { from, to };
  }
  emit();
}
